export default {
  'menu.workbenchGroup': 'Workbench',
  'menu.workbench': 'Workbench',
  'menu.activitiesGroup': 'Activities',
  'menu.activities': 'Activities',
  'menu.activityDetail': 'Activity Detail',
  'menu.technicalNeeds': 'Technical Needs',
  'menu.technicalNeeds.leads': 'Demand Leads',
  'menu.technicalNeeds.demands': 'Technical Demands',
  'menu.leads': 'Demand Leads',
  'menu.leadDetail': 'Lead Detail',
  'menu.customers': 'Customers & Contacts',
  'menu.customers.organizations': 'Organizations',
  'menu.customers.contacts': 'Contacts',
  'menu.relations': 'Customers & Contacts',
  'menu.relations.organizations': 'Organizations',
  'menu.relations.contacts': 'Contacts',
  'menu.organizations': 'Organizations',
  'menu.contacts': 'Contacts',
  'menu.organizationDetail': 'Organization Detail',
  'menu.contactDetail': 'Contact Detail',
  'menu.demands': 'Technical Demands',
  'menu.demandDetail': 'Demand Detail',
  'menu.technicalResources': 'Technical Resources',
  'menu.technicalResources.experts': 'Experts',
  'menu.technicalResources.technologies': 'Technologies',
  'menu.resources': 'Technical Resources',
  'menu.resources.experts': 'Experts',
  'menu.resources.technologies': 'Technologies',
  'menu.resources.suppliers': 'Organizations',
  'menu.experts': 'Experts',
  'menu.technologies': 'Technologies',
  'menu.businessConversion': 'Business Conversion',
  'menu.businessConversion.matchmaking': 'Matchmaking',
  'menu.businessConversion.engagements': 'Engagements',
  'menu.businessConversion.opportunities': 'Opportunities',
  'menu.businessConversion.conversionBusinesses': 'Conversion Businesses',
  'menu.matchmaking': 'Matchmaking',
  'menu.engagements': 'Engagements',
  'menu.expertDetail': 'Expert Detail',
  'menu.technologyDetail': 'Technology Detail',
  'menu.supplierDetail': 'Supplier Detail',
  'menu.opportunities': 'Opportunities',
  'menu.opportunityDetail': 'Opportunity Detail',
  'menu.businessAnalytics': 'Business Analytics',
  'menu.businessDashboard': 'Business Analytics',
  'menu.personalProfile': 'Personal Profile',
  'menu.personalSettings': 'Personal & Settings',
  'menu.personalSettings.managerProfile': 'Personal Profile',
  'menu.personalSettings.businessSettings': 'Business Settings',
  'menu.personalSettings.modelSettings': 'Model Settings',
  'menu.personalSettings.dataManagement': 'Data Management',
  'menu.personalSettings.permissions': 'Permissions',
  'menu.managerProfile': 'Personal Profile',
  'menu.businessSettings': 'Business Settings',
  'menu.modelSettings': 'Model Settings',
  'menu.dataManagement': 'Data Management',
  'menu.permissions': 'Permissions',
  'menu.settings': 'Settings',
  'menu.settings.businessSettings': 'Business Settings',
  'menu.settings.modelSettings': 'Model Settings',
  'menu.settings.dataManagement': 'Data Management',
  'menu.settings.mockData': 'Data Management',
  'menu.globalSearch': 'Global Search',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings.permissions': 'Permission Management',
  'menu.login': 'Login',
  'menu.user.login': 'Login',
  'menu.user.accessDenied': 'Access Denied',
  'menu.accessDenied': 'Access Denied',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
